// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-05d47f33]{width:90px}[dir] .icon-activity[data-v-05d47f33]{cursor:pointer}[dir=ltr] .icon-activity[data-v-05d47f33]{margin-left:.5rem}[dir=rtl] .icon-activity[data-v-05d47f33]{margin-right:.5rem}.icon-activity[data-v-05d47f33]:hover{color:var(--white)!important}[dir] .icon-activity[data-v-05d47f33]:hover{background-color:var(--primary)!important}", ""]);
// Exports
module.exports = exports;
